export default __webpack_public_path__ + "static/media/united_nations.47ca8af9.svg";